.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal {
  background: white;
  border-radius: 8px;
  padding: 16px;
  max-width: 800px;
  width: 90%;
  outline: none;
}

.image {
  width: 100%;
  border-radius: 8px;
}

.info {
  padding: 12px 0;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #333;
}

.colorCircle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.link {
  color: #4fa94d;
  text-decoration: none;
  font-weight: 500;
}